import * as React from 'react';
import { LineParticipantsEvent } from './LineParticipantsEvent';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import * as ReqType from '../../../types/ServerRequests';
import { UserService } from '../../../services/UserService';
import { EventService } from '../../../services/EventService';
import LoginServices from '../../../services/LoginServices';
import { UserRole } from '../../../types/UserRole';
import { LineUserEvent } from './LineUserEvent';

/**
 * interface Props (le parametre de la classe)
 */
export interface Props {
    /**
     * event: l'évènement en question
     */
    event: ReqType.Event;
    /**
     * la fonction la fonction declenchée après l'ajout d'un utilisateur à la liste des participants
     * @param {boolean} displayParticipation
     */
    displayAddCallback: (displayParticipation: boolean) => void;
    /**
     * listParticipant: la liste des particpants
     */
    listParticipant: ReqType.Presence[];
    /**
     * addPresence: ajout d'une presence
     */
    addPresence: (r: ReqType.Presence) => void;
    /**
     * removePresence: suppression d'une presence
     * @param {number} n
     */
    removePresence: (n: number) => void;
}

/**
 * interface State (l'état interne de la classe ListParticipantsEvent)
 */
interface State {
    listUser: ReqType.UserView[];
}

/**
 * Ce composant représente la liste de participants à un événement. Il prend en paramétres
 * un événement, une fonction void pour afficher un callback, une liste de participants,
 * une fonction pour ajouter une participation/présence à un événement.
 * Il fais appel aux services LoginServices pour récupérer une liste d'utilisateur,
 * EventService pour ajouter et enlever des participants à un événements.
 */
export class ListParticipantsEvent extends React.Component {
    props: Props;
    state: State;

    /**
     * le construteur de la classe ListParticipantsEvent
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            listUser: [],
        };

        const userRole = LoginServices.getInstance().getType();

        if (userRole === UserRole.ADMIN.toString()) {
            this.getListeUser();
        }
    }

    /**
     * le rendu de la classe ListParticipantsEvent
     * @returns {JSX.element}
     */
    render() {
        // alert(' ' + this.state.listUser.length + ' ');
        // const userRole = LoginServices.getInstance().getType();

        const listItems = this.state.listUser.map(
            (user: ReqType.UserView) => {
                // alert(user.user_type_id);
                if (
                    (UserRole.ADMIN === user.user_type_id ||
                        UserRole.SEMI_PRO === user.user_type_id ||
                        UserRole.MEMBER === user.user_type_id) &&
                    user.status === 2
                ) {
                    return (
                        <LineUserEvent
                            user={user}
                            key={user.id}
                            addCallback={this.addInListParticipant}
                            select={this.isInParticipants(user.id)}
                        />
                    );
                } else {
                    return undefined;
                }
            }
        );

        const userRole = LoginServices.getInstance().getType();

        const listParticipant = this.props.listParticipant.map(
            (presence: ReqType.Presence) => {
                return (
                    <LineParticipantsEvent
                        presence={presence}
                        key={presence.id}
                        deleteCallback={this.deleteInListParticipant}
                        select={false}
                    />
                );
            }
        );

        return (
            <div>
                {userRole === UserRole.ADMIN.toString() ?
                    (
                        <div className="card card-default" >
                            <div className="card-header col-12">
                                <h4 className="text-white">
                                    <strong> Liste des Membres, Semi-pro, Admin </strong>
                                </h4>
                            </div>
                            <div className="card-body col-12"  style={{overflow: 'auto', maxHeight: '400px'}}>
                                <TableChorinitia
                                    header={
                                        <thead className="thead-light">
                                            <tr>
                                                <th scope="col">Photo</th>
                                                <th scope="col">Nom</th>
                                                <th scope="col">Prenom</th>
                                                <th scope="col">Pseudo</th>
                                                <th scope="col">Email</th>
                                                <th scope="col">Voir Profil</th>
                                                <th scope="col">Ajouter à l'évènement</th>
                                            </tr>
                                        </thead>
                                    }
                                >
                                    <tbody>
                                        {listItems}
                                    </tbody>
                                </TableChorinitia>
                            </div>
                        </div>
                    ) : undefined
                }
                <div className="card card-default" >
                    <div className="card-header col-12">
                        <h4 className="text-white">
                            <strong> Liste des participants </strong>
                        </h4>
                    </div>
                    <div className="card-body col-12">
                        <TableChorinitia
                            header={
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col">Photo</th>
                                        <th scope="col">Nom</th>
                                        <th scope="col">Prenom</th>
                                        <th scope="col">Pseudo</th>
                                        <th scope="col">Presence</th>
                                        {userRole === UserRole.ADMIN.toString() ?
                                            (<th scope="col">Voir Profil</th>) : undefined
                                        }
                                        {userRole === UserRole.ADMIN.toString() ?
                                            (<th scope="col">Retirer</th>) : undefined
                                        }
                                    </tr>
                                </thead>
                            }
                        >
                            <tbody>
                                {listParticipant}
                            </tbody>
                        </TableChorinitia>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * fait un get de la liste des utilisaeurs et le stock dans l'attribut listuser du state
     */
    private getListeUser(): void {
        const role = LoginServices.getInstance().getType();

        if (role === UserRole.ADMIN.toString()) {
            UserService.getInstance().getUsers().then(
                (listUser: ReqType.UserView[]) => {
                    this.setState({
                        listUser: listUser
                    });
                }
            ).catch(
                (error) => {
                    alert(JSON.stringify(error));
                }
            );
        }
    }

    /**
     * ajout d'un utilisateur à la liste des participants
     * @param {UserView} userAdd
     * @returns {Promise<void>}
     */
    private addInListParticipant = (userAdd: ReqType.UserView) => {
        // return Promise.resolve();
        return (EventService.getInstance().addParticipant(userAdd, this.props.event).then(
            (resp: ReqType.Presence) => {
                this.props.addPresence(resp);
                const userId = LoginServices.getInstance().getUserId();
                if (userId !== undefined) {
                    if (userId === userAdd.id) {
                        this.props.displayAddCallback(true);
                    }
                }
            }
        ).catch(
            (e) => alert(JSON.stringify(e))
        ));
    }

    /**
     * suppression d'un utilisateur à la liste des participants
     * @param {Presence} participation
     * @returns {Promise<void>}
     */
    private deleteInListParticipant = (participation: ReqType.Presence) => {
        return (EventService.getInstance().removeParticipant(participation).then(
            () => {
                var index = this.props.listParticipant.indexOf(participation);
                this.props.removePresence(index);

                const userId = LoginServices.getInstance().getUserId();
                if (userId !== undefined) {
                    if (userId === participation.user_id) {
                        this.props.displayAddCallback(false);
                    }
                }
                // return Promise.resolve();
            }
        ).catch(
            (e) => alert('Il y a des frais associés à cet utilisateur')
        ));
    }

    /**
     * verifie si l'utilisateur avec l'identifiant u est bien dans la base de donner
     * @param {number} u
     * @returns {boolean}
     */
    private isInParticipants(u: number): boolean {
        var foundUser = this.props.listParticipant.find(
            (p: ReqType.Presence) => {
                return (u === p.user_id);
            }
        );
        // alert('Found :' + (foundUser === undefined ? 'uuu' : foundUser.id) + ' for' + u.id);
        return foundUser !== undefined;
    }
}


// WEBPACK FOOTER //
// ./src/components/EventPage/internalComponents/ListParticipantsEvent.tsx